const OAUTH_ERROR_MESSAGES: Readonly<Record<string, string>> = {
  account_exists: 'An account already uses this email. Sign in to that account, then link Google from your account settings.',
  account_already_linked: 'This account is already linked to a different Google identity.',
  google_auth_failed: 'Google sign-in could not be completed. Please try again.',
  google_identity_in_use: 'That Google identity is already linked to another TowerPower account.',
  google_link_failed: 'Google account linking could not be completed. Please try again.',
  registration_disabled: 'New account registration is currently closed.',
};

export function getOAuthErrorMessage(search: string): string | null {
  const error = new URLSearchParams(search).get('error');
  if (!error) return null;
  return OAUTH_ERROR_MESSAGES[error] ?? 'Google sign-in could not be completed. Please try again.';
}

export function showOAuthErrorBanner(document: Document, message: string): void {
  document.getElementById('oauth-error-banner')?.remove();

  const banner = document.createElement('div');
  banner.id = 'oauth-error-banner';
  banner.setAttribute('role', 'alert');
  banner.textContent = message;
  banner.style.cssText = `
    position: fixed;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 4000;
    max-width: min(560px, calc(100vw - 32px));
    padding: 12px 16px;
    border: 1px solid #d8ac67;
    border-radius: 6px;
    background: #241914;
    color: #fff2d0;
    font: 16px Arial, sans-serif;
    box-shadow: 0 4px 18px #000a;
  `;
  document.body.appendChild(banner);
}
